module.exports = __webpack_public_path__ + "img/rectangle3.8784eaa9.jpg";